import { useStaffAvailability } from "../../hooks/useStaffAvailability";
import pageStyles from "../../UserDetailsPage.module.css";
import { AvailabilityForm } from "./AvailabilityForm";
import { AvailabilityTable } from "./AvailabilityTable";
import styles from "./StaffAvailabilitySection.module.css";

/**
 * The form sits on the page rather than behind an "Add new" modal (reverted at
 * Dalen's request, 27-08-2026): adding availability is the reason to open this
 * tab, so it should not cost a click, and a browser time picker inside a modal
 * fights the dialog's focus trap.
 */
export const StaffAvailabilitySection = ({
  tabs,
  tenantVal,
  staffMembers = [],
}) => {
  const {
    availability,
    isLoading,
    isError,
    search,
    setSearch,
    isSaving,
    refetch,
    save,
    remove,
  } = useStaffAvailability(tenantVal);

  return (
    <>
      <div className={`${pageStyles.section} ${styles.formSection}`}>
        <div className={pageStyles.sectionHeader}>
          <h3 className={pageStyles.sectionTitle}>Add Staff Availability</h3>
        </div>

        {tabs}

        <div className={styles.card}>
          <AvailabilityForm
            staffMembers={staffMembers}
            isSaving={isSaving}
            onSave={save}
          />
        </div>
      </div>

      <div className={pageStyles.section}>
        <div className={pageStyles.sectionHeader}>
          <h3 className={pageStyles.sectionTitle}>Staff Availability</h3>
        </div>

        <AvailabilityTable
          availability={availability}
          isLoading={isLoading}
          isError={isError}
          search={search}
          onSearchChange={setSearch}
          onRetry={refetch}
          isSaving={isSaving}
          onSave={save}
          onDelete={remove}
        />
      </div>
    </>
  );
};
